import { Box } from "@chakra-ui/react";

import OrganizationServiceTimePerServiceTable from "../../tables/daily/OrganizationServiceTimePerServiceTable";
import EnterpriseReportSummary from "../../../reports/EnterpriseReportSummary";
import { buildDurationInsights } from "../../../../store/reportEnterpriseInsights";
import { formatTime } from "../../../../store/helpers";

const OrganizationServiceTimePerService = ({
  branchId = null,
  
  branchIndex,
  data,
  numServices = 0,
  branchName = "",
}) => {
  const insights = buildDurationInsights(data, {
    metric: "service",
    scopeLabel: "Service",
    formatDuration: formatTime,
  });

  return (
    <Box>
      <EnterpriseReportSummary
        title="Daily Service Handling Time Summary"
        kpis={insights.kpis}
        tables={insights.tables}
        notes={insights.notes}
      />
      <OrganizationServiceTimePerServiceTable
        branchId={branchId}
        data={data}
        numServices={numServices}
        branchName={branchName}
        
        branchIndex={branchIndex}
      />
    </Box>
  );
};

export default OrganizationServiceTimePerService;
